import React, { useState } from "react";
import Image from "components/image";
import Link from "helpers/link";
import ProductFinder from "@root/components/product-finder";

/**
 *
 *     { type: "Car / Truck / SUV / Van", value: "car" },
 *     { type: "Boat", value: "boat" },
 *     { type: "Jet Skis", value: "jet_ski" },
 *     { type: "Bimini Tops", value: "bimini" },
 *     { type: "Pontoon", value: "pontoon" },
 *     { type: "Motorcycle", value: "motorcycle" },
 *     { type: "Scooter", value: "scooter" },
 *     { type: "ATV", value: "atv" },
 *     { type: "UTV", value: "utv" },
 *     { type: "Snowmobile", value: "snowmobile" },
 *     { type: "RV", value: "rv" },
 */

const titles = {
    'car': 'Car / Truck / SUV / Van',
    'boat': 'Boat',
    'jet_ski': 'Jet Skis',
    'bimini': 'Bimini Tops',
    'pontoon': 'Pontoon',
    'motorcycle': 'Motorcycle',
    'scooter': 'Scooter',
    'atv': 'ATV',
    'utv': 'UTV',
    'snowmobile': 'Snowmobile',
    'rv': 'RV',
};

const images = {
    'car': 'https://cdn.shopify.com/s/files/1/0168/9760/5686/files/BANNERS_CARS_1.png?v=1790080479',
    'boat': 'https://cdn.shopify.com/s/files/1/0168/9760/5686/files/2_1_8674acf7-5c77-4f91-885b-e0c133cbd660.png?v=1790172249',
    'jet_ski': 'https://cdn.shopify.com/s/files/1/0168/9760/5686/files/jetski-banner-image_1.jpg?v=1790172339',
    'bimini': 'https://cdn.shopify.com/s/files/1/0168/9760/5686/files/BANNERS_SNOWMOBILE.png?v=1790172413',
    'pontoon': 'https://cdn.shopify.com/s/files/1/0168/9760/5686/files/BANNERS_PONTOON.png?v=1790172484',
    'motorcycle': 'https://cdn.shopify.com/s/files/1/0168/9760/5686/files/BANNERS_MOTOR_1.png?v=1790172565',
    'scooter': 'https://cdn.shopify.com/s/files/1/0168/9760/5686/files/BANNERS_SCOOTER.png?v=1790172705',
    'atv': 'https://cdn.shopify.com/s/files/1/0168/9760/5686/files/BANNERS_ATV.png?v=1790172705',
    'utv': 'https://cdn.shopify.com/s/files/1/0168/9760/5686/files/BANNERS_UTV.png?v=1790172705',
    'snowmobile': 'https://cdn.shopify.com/s/files/1/0168/9760/5686/files/BANNERS_SNOWMOBILE_1.png?v=1790172705',
    'rv': 'https://cdn.shopify.com/s/files/1/0168/9760/5686/files/2_11_1.png?v=1790172067',
    'default': 'https://cdn.shopify.com/s/files/1/0168/9760/5686/files/BANNERS_CARS_1.png?v=1790080479',
}

const Hero = ({ data: { image, title, description, ctaButton } }) => {

    let [ finderType, setFinderType ] = useState('car');
    let imageUrl = images[finderType] || images['default'];
    let [renderKey, setRenderKey] = useState(0);

    return (
        <div className="flex relative hero-banner" style={{ marginTop: -16 }}>
            <div className="absolute w-full h-full z-0 before:z-10 before:top-0 before:right-0 before:left-0 before:bottom-0 before:absolute xsm:before:bg-gray-701 xsm:before:opacity-40">
                <Image image={imageUrl} className="w-full h-full" />
            </div>
            <div className="container flex flex-col font xsm:pt-8 pt-12 xsm:pb-24 pb-20 z-100">
                <h2 className="hero-banner__title" style={{zIndex: 10}}>Find Your <span>{ titles[finderType] } Cover</span></h2>
                <ProductFinder
                    onTypeChange={(type) => {
                        setFinderType(type)
                        setRenderKey(renderKey + 1);
                    }}
                    showType={true}
                    newFinder={true}
                    key={finderType + '-' + renderKey}
                    data={{
                        showType: true,
                        collectionType: finderType,
                        isQuickProductCreator: false,
                        isHero: true,
                        bgImage: null,
                        backgroundColor: "transparent"
                    }}
                />
            </div>
        </div>
    )
};

export default Hero;
